import type { Temporal } from 'temporal-polyfill';
import { realClock } from '@/models/common/realClock.ts';
import { testClock } from '@/models/common/testClock.ts';

export type ClockType = {
  readonly getTimeZone: () => string;
  readonly getInstant: () => Temporal.Instant;
  readonly getPlainDateISO: () => Temporal.PlainDate;
  readonly getZonedDateTimeISO: () => Temporal.ZonedDateTime;
};

let impl: ClockType;
if (import.meta.env.DEV) {
  impl = testClock;
} else {
  impl = realClock;
}

export const clock = impl;
